import requestHandler from 'portal-base/src/decorators/RequestHandler';

class AlarmingRepository {
    static target = portalConfig.portalBaseUrl;

    setTarget(target) {
        AlarmingRepository.target = target;
    }

    @requestHandler()
    getAlarmConfigurations(channelId) {
        const url = `${AlarmingRepository.target}shares/channels/${channelId}/alarmConfigurations`;
        return fetch(url);
    }

    @requestHandler()
    getAlarmStatus(channelId, maxAge = 8640000) {
        const url = `${AlarmingRepository.target}shares/channels/${channelId}/alarmingStatus?maxAge=${maxAge}`;
        return fetch(url);
    }
}

export const AlarmingStore = new AlarmingRepository();
